import { library } from '@fortawesome/fontawesome-svg-core'

import { faCirclePlus as fatCirclePlus } from '@fortawesome/pro-thin-svg-icons/faCirclePlus'
import { faCircleXmark as fatCircleXmark } from '@fortawesome/pro-thin-svg-icons/faCircleXmark'

library.add(fatCirclePlus, fatCircleXmark)

import { faLoader as fadLoader } from '@fortawesome/pro-duotone-svg-icons/faLoader'
import { faRightLeft as fadRightLeft } from '@fortawesome/pro-duotone-svg-icons/faRightLeft'
import { faSpinnerThird as fadSpinnerThird } from '@fortawesome/pro-duotone-svg-icons/faSpinnerThird'

import { faCircle as fadtFaCircle } from '@fortawesome/duotone-thin-svg-icons'
import { faCircle as fadrFaCircle } from '@fortawesome/duotone-regular-svg-icons'

library.add(
  fadLoader,
  fadRightLeft,
  fadSpinnerThird,
  fadtFaCircle,
  fadrFaCircle
)

import { faAngleDown as fasAngleDown } from '@fortawesome/pro-solid-svg-icons/faAngleDown'
import { faAngleLeft as fasAngleLeft } from '@fortawesome/pro-solid-svg-icons/faAngleLeft'
import { faArrowLeft as fasArrowLeft } from '@fortawesome/pro-solid-svg-icons/faArrowLeft'
import { faArrowRightLong as fasArrowRightLong } from '@fortawesome/pro-solid-svg-icons/faArrowRightLong'
import { faCat as fasCat } from '@fortawesome/pro-solid-svg-icons/faCat'
import { faCheck as fasCheck } from '@fortawesome/pro-solid-svg-icons/faCheck'
import { faChevronRight as fasChevronRight } from '@fortawesome/pro-solid-svg-icons/faChevronRight'
import { faChevronUp as fasChevronUp } from '@fortawesome/pro-solid-svg-icons/faChevronUp'
import { faCircle as fasCircle } from '@fortawesome/pro-solid-svg-icons/faCircle'
import { faCircleExclamation as fasCircleExclamation } from '@fortawesome/pro-solid-svg-icons/faCircleExclamation'
import { faCircleXmark as fasCircleXmark } from '@fortawesome/pro-solid-svg-icons/faCircleXmark'
import { faCopy as fasCopy } from '@fortawesome/pro-solid-svg-icons/faCopy'
import { faDownload as fasDownload } from '@fortawesome/pro-solid-svg-icons/faDownload'
import { faDog as fasDog } from '@fortawesome/pro-solid-svg-icons/faDog'
import { faEnvelope as fasEnvelope } from '@fortawesome/pro-solid-svg-icons/faEnvelope'
import { faEnvelopeOpenText as fasEnvelopeOpenText } from '@fortawesome/pro-solid-svg-icons/faEnvelopeOpenText'
import { faMinus as fasMinus } from '@fortawesome/pro-solid-svg-icons/faMinus'
import { faPencil as fasPencil } from '@fortawesome/pro-solid-svg-icons/faPencil'
import { faPhone as fasPhone } from '@fortawesome/pro-solid-svg-icons/faPhone'
import { faPlus as fasPlus } from '@fortawesome/pro-solid-svg-icons/faPlus'
import { faSquareCheck as fasSquareCheck } from '@fortawesome/pro-solid-svg-icons/faSquareCheck'
import { faXmark as fasXmark } from '@fortawesome/pro-solid-svg-icons/faXmark'

library.add(
  fasAngleDown,
  fasAngleLeft,
  fasArrowLeft,
  fasArrowRightLong,
  fasCat,
  fasCheck,
  fasChevronRight,
  fasChevronUp,
  fasCircle,
  fasCircleExclamation,
  fasCircleXmark,
  fasCopy,
  fasDownload,
  fasDog,
  fasEnvelope,
  fasEnvelopeOpenText,
  fasMinus,
  fasPencil,
  fasPhone,
  fasPlus,
  fasSquareCheck,
  fasXmark
)

import { faArrowLeft as farArrowLeft } from '@fortawesome/pro-regular-svg-icons/faArrowLeft'
import { faCheck as farCheck } from '@fortawesome/pro-regular-svg-icons/faCheck'
import { faCircle as farCircle } from '@fortawesome/pro-regular-svg-icons/faCircle'
import { faCircleCheck as farCircleCheck } from '@fortawesome/pro-regular-svg-icons/faCircleCheck'
import { faCircleExclamation as farCircleExclamation } from '@fortawesome/pro-regular-svg-icons/faCircleExclamation'
import { faCircleInfo as farCircleInfo } from '@fortawesome/pro-regular-svg-icons/faCircleInfo'
import { faFile as farFile } from '@fortawesome/pro-regular-svg-icons/faFile'
import { faMinus as farMinus } from '@fortawesome/pro-regular-svg-icons/faMinus'
import { faPlus as farPlus } from '@fortawesome/pro-regular-svg-icons/faPlus'
import { faSquare as farSquare } from '@fortawesome/pro-regular-svg-icons/faSquare'

library.add(
  farArrowLeft,
  farCheck,
  farCircle,
  farCircleCheck,
  farCircleExclamation,
  farCircleInfo,
  farFile,
  farMinus,
  farPlus,
  farSquare
)

import { faAngleDown as falAngleDown } from '@fortawesome/pro-light-svg-icons/faAngleDown'
import { faCat as falCat } from '@fortawesome/pro-light-svg-icons/faCat'
import { faChevronDown as falChevronDown } from '@fortawesome/pro-light-svg-icons/faChevronDown'
import { faChevronRight as falChevronRight } from '@fortawesome/pro-light-svg-icons/faChevronRight'
import { faChevronUp as falChevronUp } from '@fortawesome/pro-light-svg-icons/faChevronUp'
import { faCircle as falCircle } from '@fortawesome/pro-light-svg-icons/faCircle'
import { faDog as falDog } from '@fortawesome/pro-light-svg-icons/faDog'
import { faMoon as falMoon } from '@fortawesome/pro-light-svg-icons/faMoon'
import { faPaw as falPaw } from '@fortawesome/pro-light-svg-icons/faPaw'
import { faStar as falStar } from '@fortawesome/pro-light-svg-icons/faStar'
import { faSunBright as falSunBright } from '@fortawesome/pro-light-svg-icons/faSunBright'
import { faUser as falUser } from '@fortawesome/pro-light-svg-icons/faUser'
import { faXmark as falXmark } from '@fortawesome/pro-light-svg-icons/faXmark'

library.add(
  falAngleDown,
  falCat,
  falChevronDown,
  falChevronRight,
  falChevronUp,
  falCircle,
  falDog,
  falMoon,
  falPaw,
  falSunBright,
  falStar,
  falUser,
  falXmark
)

export { FontAwesomeIcon as default } from '@fortawesome/vue-fontawesome'

export const ART = {
  fad: 'duo',
  far: 'regular',
  fat: 'thin',
  fal: 'light',
  fas: 'solid',
}
